var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.297,
    height: 23.338,
    viewBox: "0 0 33.297 23.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_98010",
    "data-name": "Trazado 98010",
    d: "M281.621,10.687a4.193,4.193,0,0,1,2.949,2.949,43.5,43.5,0,0,1,.727,8.014,42.709,42.709,0,0,1-.705,8.014,4.194,4.194,0,0,1-2.949,2.949c-2.586.705-12.994.705-12.994.705s-10.408,0-12.994-.705a4.193,4.193,0,0,1-2.949-2.949A42.833,42.833,0,0,1,252,21.651a43.786,43.786,0,0,1,.684-7.993,4.192,4.192,0,0,1,2.949-2.949c2.586-.705,12.993-.727,12.993-.727S279.035,9.982,281.621,10.687Zm-7.672,10.964-8.634,5v-10Z",
    transform: "translate(-252 -9.982)",
    fill: "#224a8d",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.dff5db068b34b9accc0959857b7b26fe.svg";
export { ForwardRef as ReactComponent };